declare global {
    interface Window {
        gameEnginePath?: string
    }
}

const stripTrailingSlash = (value: string): string => value.replace(/\/+$/, '')

/**
 * The launcher declares the variable on the page that hosts the game. When an operator embeds that
 * page in a frame the value sits on an ancestor instead, and reading a cross-origin ancestor throws.
 */
const readInjectedPath = (source: Window | null): string => {
    try {
        return String(source?.gameEnginePath || '').trim()
    } catch {
        return ''
    }
}

/**
 * Domain injected by the PHP launcher (`core_config_changes.js`). Same variable in stage and prod:
 * the host itself changes per env and operator (Dragon Gaming / ONYX / BOL vs Fliff).
 */
export const getGameEnginePath = (): string => {
    if (typeof window === 'undefined') {
        return ''
    }

    for (const source of [window, window.parent, window.top]) {
        const injected = readInjectedPath(source)

        if (injected) {
            return stripTrailingSlash(injected)
        }
    }

    const host = (window.location.hostname || '').toLowerCase()
    if (!host || host === 'localhost' || host === '127.0.0.1') {
        return ''
    }

    return stripTrailingSlash(window.location.origin)
}
